module.exports = __webpack_public_path__ + "media/images/clients/client_baner-f5040d75f650ea5f1d395d481997c5c2.png";